import {PwaInstallPrompt} from '@app/web-player/player/pwa-install-prompt';
import {PersistentPlayerMount} from '@app/web-player/player/persistent-player-mount';
import {useBackgroundPlayback} from '@app/web-player/player/use-background-playback';
import {GlobalPlayerBar} from '@app/web-player/player/global-player-bar';
import {playerStoreOptions} from '@app/web-player/state/player-store-options';
import {SettingsPreviewListener} from '@common/admin/settings/preview/settings-preview-listener';
import {
  GlobalTopLoadingBar,
} from '@common/core/common-provider';
import {PlayerContext} from '@common/player/player-context';
import {CookieNotice} from '@common/ui/cookie-notice/cookie-notice';
import {DialogStoreOutlet} from '@ui/overlays/store/dialog-store-outlet';
import {ToastContainer} from '@ui/toast/toast-container';
import {Fragment} from 'react';
import {Outlet, ScrollRestoration} from 'react-router';

/** App root: single player store + persistent media engine for all routes. */
export function AppRootRoute() {
  return (
    <PlayerContext id="web-player" options={playerStoreOptions}>
      <AppRootRouteInner />
    </PlayerContext>
  );
}

function AppRootRouteInner() {
  useBackgroundPlayback();

  return (
    <Fragment>
      <PersistentPlayerMount />
      <GlobalTopLoadingBar />
      <Outlet />
      <GlobalPlayerBar />
      <SettingsPreviewListener />
      <CookieNotice />
      <ToastContainer />
      <DialogStoreOutlet />
      <ScrollRestoration />
      <PwaInstallPrompt />
    </Fragment>
  );
}
